// 空提示
<template>
  <div class="tips-box">
    <img :src="icon" alt="" class="empty-icon">
    <p class="tips">{{textObj.tips}}</p>
    <p class="exta">{{textObj.exta}}</p>
  </div>
</template>
<script>
export default {
name:'',
mixins:[],
components:{},
// 数据部分
props:{
  icon:{
    type:String,
    default:require("../assets/empty/no-data.png")
  },
  textObj:{
    type:Object,
    default:()=>({
      tips:"非常抱歉",
      exta: "没有找到相关的宝贝"
    })
  }
},
data() {
 return {};
},
computed: {},
watch: {},
// 生命周期
created() {},
mounted() {},
unmounted() {},
// 方法
 methods:{},
}; 
</script>
<style lang="less" scoped>
.tips-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  .empty-icon{
    width: 400px;
    height: 400px;
    margin-bottom: 34px;
  }
  .tips{
    font-size: 28px;
    margin-bottom: 20px;
    color: #111A34;
  }
  .exta{
    color: #41485D;
    font-size: 24px;
  }
}
</style>